import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import {
  EntityWithMetadataTableSuffixColumns,
  createConnectionFilterSpec,
  formatEvidenceName,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";
import { TeamMember } from "../../types/teamMember";

const columnHelper = createMRTColumnHelper<TeamMember>();

export const teamMemberConnectionColumns: MRT_ColumnDef<TeamMember, any>[] = [
  columnHelper.accessor("fromDoc", {
    header: "Team",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("toDoc", {
    header: "Person",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("role", {
    header: "Role",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("name_internal_evidence", {
    header: "Name Internal Evidence",
    Cell: ({ cell }) =>
      cell.getValue() ? formatEvidenceName(cell.getValue()) : "-",
  }),
  columnHelper.accessor("name_external_evidence", {
    header: "Name External Evidence",
    Cell: ({ cell }) =>
      cell.getValue() ? formatEvidenceName(cell.getValue()) : "-",
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

export const teamMemberFilterSpec: FilterSpec = createConnectionFilterSpec({
  status: { kind: "string" },
  role: { kind: "string" },
  name_internal_evidence: { kind: "string" },
  name_external_evidence: { kind: "string" },
});
